import { type AlertColor } from "@mui/material/Alert";

export interface RubriqueSanteAnimalType {
  id: number;
  name: string;
  nameEn: string;
  type: string;
  title: string;
}
export interface loadObjectType {
  isAlert: boolean;
  message: string;
  alertSeverity: AlertColor;
  isLoading: boolean;
}

export const defaultSelectedItemMpsa: RubriqueSanteAnimalType = {
  id: 0,
  name: "",
  nameEn: "",
  type: "",
  title: "",
};
